// AUPRÉA — Étape 11 : écran de signature des contrats (recrue / consultant)
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { C, Btn, Input, Spinner, Alert } from "./shared";
import { API, hdrs, TEAL, OR, ROUGE, fr, errMsg } from "./integrationShared";

const TZ = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Guadeloupe";
export const ouvrirPdf = async (url) => {
  const r = await axios.get(`${API}${url}`, { ...hdrs(), responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank");
};

const InfosLegales = ({ infos, onSaved }) => {
  const [f, setF] = useState(infos); const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true); setErr("");
    try { await axios.put(`${API}/integration/infos-legales`, f, hdrs()); onSaved(); } catch (e) { setErr(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div style={{ background: "#F7F6F3", borderRadius: 10, padding: 14, marginBottom: 14 }} data-testid="infos-legales">
      <div style={{ fontSize: 13, fontWeight: 600, color: C.navy, marginBottom: 4 }}>1. Vos informations légales</div>
      <div style={{ fontSize: 11, color: C.mid, marginBottom: 10 }}>Elles seront reprises dans vos contrats.</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 8 }}>
        <Input placeholder="Raison sociale (si société)" value={f.raison_sociale} onChange={e => setF({ ...f, raison_sociale: e.target.value })} data-testid="legal-raison-sociale" />
        <Input placeholder="SIRET (14 chiffres)" value={f.siret} onChange={e => setF({ ...f, siret: e.target.value.replace(/\D/g, "").slice(0, 14) })} data-testid="legal-siret" />
        <Input placeholder="Adresse complète" value={f.adresse} onChange={e => setF({ ...f, adresse: e.target.value })} data-testid="legal-adresse" style={{ gridColumn: "1 / -1" }} />
        <Input placeholder="Téléphone" value={f.telephone} onChange={e => setF({ ...f, telephone: e.target.value })} data-testid="legal-telephone" />
      </div>
      {err && <div style={{ color: ROUGE, fontSize: 11, marginTop: 6 }} data-testid="legal-erreur">{err}</div>}
      <div style={{ marginTop: 10 }}><Btn small variant="gold" disabled={busy} onClick={save} data-testid="legal-save">Enregistrer mes informations</Btn></div>
    </div>
  );
};

const ContratLecture = ({ c, lu, setLu, coche, setCoche }) => {
  const ref = useRef(null);
  const check = () => { const el = ref.current; if (el && el.scrollTop + el.clientHeight >= el.scrollHeight - 8) setLu(true); };
  useEffect(() => { check(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div style={{ border: `.5px solid ${C.border}`, borderRadius: 10, marginBottom: 14, background: "#fff" }} data-testid={`contrat-${c.modele_id}`}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", borderBottom: `.5px solid ${C.border}`, gap: 8, flexWrap: "wrap" }}>
        <div style={{ fontWeight: 600, color: C.navy, fontSize: 13 }}>{c.titre} <span style={{ color: OR, fontSize: 11 }}>· version {c.version}</span>{!c.obligatoire && <span style={{ color: C.muted, fontSize: 10 }}> (facultatif)</span>}</div>
        <Btn small onClick={() => ouvrirPdf(`/integration/contrats/${c.modele_id}/pdf?tz=${encodeURIComponent(TZ)}`)} data-testid={`contrat-${c.modele_id}-pdf`}>⬇ Télécharger en PDF</Btn>
      </div>
      <div ref={ref} onScroll={check} className="aup-contrat-texte" style={{ maxHeight: 380, overflowY: "auto", padding: "14px 18px", fontSize: 12.5, lineHeight: 1.6 }}
        dangerouslySetInnerHTML={{ __html: c.html }} data-testid={`contrat-${c.modele_id}-texte`} />
      <div style={{ padding: "10px 14px", borderTop: `.5px solid ${C.border}`, background: lu ? "#F0F7F5" : "#FFF8EB" }}>
        {!lu && <div style={{ fontSize: 11, color: OR, marginBottom: 6 }} data-testid={`contrat-${c.modele_id}-lire`}>↓ Faites défiler le document jusqu'à la fin pour pouvoir l'accepter</div>}
        <label style={{ display: "flex", gap: 8, fontSize: 12.5, cursor: lu ? "pointer" : "not-allowed", opacity: lu ? 1 : .5 }}>
          <input type="checkbox" disabled={!lu} checked={coche} onChange={e => setCoche(e.target.checked)} data-testid={`contrat-${c.modele_id}-accepte`} />
          J'ai lu et j'accepte le {c.titre} (version {c.version})
        </label>
      </div>
    </div>
  );
};

export const SignatureContrats = ({ onDone }) => {
  const [d, setD] = useState(null); const [lu, setLu] = useState({}); const [coche, setCoche] = useState({});
  const [mention, setMention] = useState(""); const [nom, setNom] = useState(""); const [code, setCode] = useState("");
  const [envoye, setEnvoye] = useState(null); const [msg, setMsg] = useState(null); const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/integration/contrats?tz=${encodeURIComponent(TZ)}`, hdrs()).then(r => setD(r.data)).catch(e => setMsg({ err: true, t: errMsg(e) }));
  useEffect(() => { load(); }, []);
  if (!d) return msg ? <Alert type="error"><span>⚠</span><span>{msg.t}</span></Alert> : <Spinner />;
  const aSigner = d.contrats.filter(c => !c.deja_signe);
  const choisis = aSigner.filter(c => coche[c.modele_id]);
  const pret = d.infos_ok && aSigner.filter(c => c.obligatoire).every(c => coche[c.modele_id]) && choisis.length > 0 && mention.trim().toLowerCase() === "lu et approuvé" && nom.trim().length >= 3;
  const demanderCode = async () => {
    setBusy(true); setMsg(null);
    try {
      const r = await axios.post(`${API}/integration/contrats/code`, { contrats: choisis.map(c => ({ modele_id: c.modele_id, version: c.version, sha256: c.sha256 })), nom, mention, tz: TZ }, hdrs());
      setEnvoye(r.data); setCode("");
    } catch (e) { setMsg({ err: true, t: errMsg(e) }); }
    setBusy(false);
  };
  const signer = async () => {
    setBusy(true); setMsg(null);
    try {
      await axios.post(`${API}/integration/contrats/signer`, { code }, hdrs());
      setEnvoye(null); setCoche({}); setMention(""); setNom(""); setMsg({ err: false, t: "Contrats signés ✓ Votre exemplaire signé vous a été envoyé par e-mail." });
      load(); onDone && onDone();
    } catch (e) { setMsg({ err: true, t: errMsg(e) }); }
    setBusy(false);
  };
  return (
    <div data-testid="signature-contrats">
      <style>{`.aup-contrat-texte table{border-collapse:collapse;width:100%;margin:8px 0}.aup-contrat-texte td,.aup-contrat-texte th{border:1px solid #ccc;padding:5px}.aup-contrat-texte h1,.aup-contrat-texte h2,.aup-contrat-texte h3{color:${C.navy};font-family:'Playfair Display',serif}`}</style>
      {msg && !envoye && <div style={{ padding: "8px 12px", borderRadius: 8, fontSize: 12, marginBottom: 12, background: msg.err ? "#FEF2F2" : "#F0F7F5", color: msg.err ? ROUGE : TEAL }} data-testid={msg.err ? "signature-erreur" : "signature-ok"}>{msg.t}</div>}
      {aSigner.length === 0 ? (
        <div style={{ fontSize: 13, color: d.signes.length ? TEAL : C.mid }} data-testid="aucun-contrat">{d.signes.length ? "✓ Tous vos contrats sont signés." : "Aucun contrat à signer pour le moment : AUPRÉA vous préviendra dès qu'ils seront prêts."}</div>
      ) : (
        <>
          <InfosLegales infos={d.infos_legales} onSaved={load} />
          <div style={{ fontSize: 13, fontWeight: 600, color: C.navy, margin: "4px 0 10px" }}>2. Lisez et acceptez chaque contrat</div>
          <div style={{ opacity: d.infos_ok ? 1 : .45, pointerEvents: d.infos_ok ? "auto" : "none" }}>
            {aSigner.map(c => <ContratLecture key={c.modele_id + c.version} c={c} lu={!!lu[c.modele_id]} setLu={v => setLu(s => ({ ...s, [c.modele_id]: v }))}
              coche={!!coche[c.modele_id]} setCoche={v => setCoche(s => ({ ...s, [c.modele_id]: v }))} />)}
            <div style={{ fontSize: 13, fontWeight: 600, color: C.navy, margin: "4px 0 10px" }}>3. Confirmez votre signature</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 8 }}>
              <Input placeholder="Saisissez « Lu et approuvé »" value={mention} onChange={e => setMention(e.target.value)} data-testid="signature-mention" />
              <Input placeholder="Votre nom complet" value={nom} onChange={e => setNom(e.target.value)} data-testid="signature-nom" />
            </div>
            {!envoye ? (
              <div style={{ marginTop: 12 }}><Btn variant="gold" disabled={!pret || busy} onClick={demanderCode} data-testid="btn-recevoir-code">{busy ? "Envoi…" : "Recevoir mon code de confirmation"}</Btn></div>
            ) : (
              <div style={{ marginTop: 12, background: "#F7F6F3", padding: 12, borderRadius: 10 }} data-testid="bloc-code">
                <div style={{ fontSize: 12, color: C.mid, marginBottom: 8 }}>Code à 6 chiffres envoyé par e-mail à {envoye.email} · valable {envoye.expire_minutes} min · 3 essais.</div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <Input placeholder="______" value={code} maxLength={6} onChange={e => setCode(e.target.value.replace(/\D/g, ""))} style={{ width: 140, letterSpacing: 6, fontSize: 18, textAlign: "center" }} data-testid="signature-code" />
                  <Btn variant="gold" disabled={code.length !== 6 || busy} onClick={signer} data-testid="btn-signer">{busy ? "Signature…" : "Signer électroniquement"}</Btn>
                  <Btn small onClick={demanderCode} disabled={busy} data-testid="btn-nouveau-code">Renvoyer un code</Btn>
                </div>
                {msg && <div style={{ fontSize: 12, marginTop: 8, color: msg.err ? ROUGE : TEAL }} data-testid={msg.err ? "signature-erreur" : "signature-ok"}>{msg.t}</div>}
              </div>
            )}
          </div>
        </>
      )}
      {d.signes.length > 0 && (
        <div style={{ marginTop: 18 }} data-testid="contrats-deja-signes">
          <div style={{ fontSize: 11, fontWeight: 700, color: C.mid, textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 6 }}>Mes contrats signés</div>
          {d.signes.map(p => (
            <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, padding: "6px 0", borderBottom: `.5px solid ${C.border}`, fontSize: 12 }}>
              <span>{p.titre} · v{p.version} · signé le {fr(p.signed_at)}</span>
              <Btn small onClick={() => ouvrirPdf(`/contrats-preuves/${p.id}/pdf`)} data-testid={`mon-pdf-${p.id}`}>Voir le PDF signé</Btn>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
